// src/Zustand/AuthStore.js
import { create } from "zustand";
const useAuthStore = create((set) => ({

  mode:1,
  isLoggedIn: false,
  userData: null,
  access : "User",
  login: (data) => set({ isLoggedIn: true, userData: data }),
  logout: () => {
    localStorage.removeItem("token");
    return set({ isLoggedIn: false, userData: null, access: "User" });
  },
  setAccess: (access = "User") => set({ access: access}),

  setMode: (data) => set({ mode: data }),

  resetAuth: () => set({ isLoggedIn: false, userData: null, access: "User", mode:1 }),
}));
export default useAuthStore;
